var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_connecting_1048107_000000 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4383 6.06641L16.2505 7.25421L20.996 11.9997L16.2512 16.7462L17.439 17.934L23.3735 11.9995L17.4383 6.06641ZM7.74828 7.25515L6.56047 6.06734L0.626953 12.0009L6.56143 17.9344L7.74924 16.7466L3.00276 12.0011L7.74828 7.25515ZM7.31983 12.8407H9.38983V11.1607H7.31983V12.8407ZM10.965 12.8407H13.035V11.1607H10.965V12.8407ZM16.6798 11.1607H14.6098V12.8407H16.6798V11.1607Z",
    fill: "#ADADB0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsInactive);
export default __webpack_public_path__ + "static/media/integrations_inactive.a337a6259e3e151a77da13747ec5aecd.svg";
export { ForwardRef as ReactComponent };